// Manual override: the auto-grader settles tickets; these let the owner force WON / LOST (or hand it back).
export default function SettleButtons({ ticket, onSettle, small = false }) {
  const sz = small ? 'text-[9px] px-1.5 py-0.5' : 'text-[11px] px-2 py-1';
  const m = ticket.manual_result;
  if (m) {
    return (
      <div className="relative z-20 flex items-center gap-1.5" data-testid={`settle-manual-${ticket.id}`}>
        <span className={`${sz} rounded font-bold ${m === 'won' ? 'bg-emerald-500/20 text-emerald-300' : 'bg-red-500/20 text-red-300'}`}>Marked {m.toUpperCase()} by you</span>
        <button type="button" onClick={() => onSettle(ticket, 'auto')} className={`${sz} rounded border border-zinc-600 text-zinc-300 hover:text-white`} data-testid={`settle-auto-${ticket.id}`}>Undo</button>
      </div>
    );
  }
  return (
    <div className="relative z-20 flex items-center gap-1.5" data-testid={`settle-buttons-${ticket.id}`}>
      <button type="button" onClick={() => onSettle(ticket, 'won')} className={`${sz} rounded border border-emerald-500/50 font-semibold text-emerald-300 hover:bg-emerald-500/10`} data-testid={`settle-won-${ticket.id}`}>Mark won</button>
      <button type="button" onClick={() => onSettle(ticket, 'lost')} className={`${sz} rounded border border-red-500/50 font-semibold text-red-300 hover:bg-red-500/10`} data-testid={`settle-lost-${ticket.id}`}>Mark lost</button>
    </div>
  );
}
